import dataUsageIcon from "@ms/data_usage.svg?raw";
import { Icon } from "./Icon";
import "./Loader.css";
import { Stack } from "./Stack";

type Props = {
	/**
	 * The color of the loader.
	 * @default var(--gvt-primary)
	 */
	color?: string;
	/**
	 * The size of the loader.
	 * @values xsmall = 0.75rem, small = 1rem, medium = auto, large = 2rem
	 * @default auto
	 */
	size?: "xsmall" | "small" | "medium" | "large";
};
/**
 * Centered spinning activity indicator for loading states.
 *
 * [Design System →](http://localhost:5174/component/Loading%20States)
 */

const sizeMap = {
	xsmall: "0.75rem",
	small: "1rem",
	medium: "auto",
	large: "2rem",
};
export const Loader = (props: Props) => {
	const size = sizeMap[props.size ?? "medium"];
	return (
		<Stack
			direction="row"
			style={{ color: props.color ?? "var(--gvt-primary)" }}
			align="center"
			justify="center"
			class="gvtui-loader"
		>
			<Icon style={{ width: size, height: size }} icon={dataUsageIcon} />
		</Stack>
	);
};
